import Api from '@disco/api/public-channels'
import { loadBatch } from '@disco/state-management/actions/PlaylistTrackActions'
import type { Group } from 'types/group'
import type { PublicPlaylist } from 'types/public-playlist'
import type { RootGroup } from 'types/shareable-channel'
import * as actions from './actions'
import { getSearchState } from './selectors'
let _abortController: AbortController | null | undefined = null
export const publicSearch =
  (
    q: string,
    group: Group | RootGroup,
    playlist?: PublicPlaylist,
  ): ((dispatch: any) => Promise<any>) =>
  async (dispatch: (...args: Array<any>) => any) => {
    try {
      dispatch(actions.publicSearch(q, group, playlist))
      if (_abortController) _abortController.abort()
      _abortController = new AbortController()
      const api = new Api()
      const response = await api.publicSearch(
        group,
        {
          q,
          playlist_version_id: playlist ? playlist.id : undefined,
        },
        _abortController.signal,
      )
      dispatch(loadBatch(response.results))
      dispatch(actions.publicSearchSuccess(q, group, playlist, response))
    } catch (error) {
      return dispatch(actions.publicSearchFail(q, group, playlist, error))
    }
  }
export const publicSearchNext =
  (): ((dispatch: any, getState: any) => Promise<any>) =>
  async (
    dispatch: (...args: Array<any>) => any,
    getState: (...args: Array<any>) => any,
  ) => {
    const state = getState()
    const searchState = getSearchState(getState())
    if (!searchState || state.view.loadingNextPage) return null
    const { groupId, next } = searchState
    if (!groupId || !next) return null

    try {
      dispatch(actions.publicSearchNext())
      const api = new Api()
      const response = await api.getGroupContentsNextPage(groupId, next)
      dispatch(loadBatch(response.results))
      dispatch(actions.publicSearchNextSuccess(response))
    } catch (error) {
      return dispatch(actions.publicSearchNextFail(error))
    }
  }

export { resetSearch, updateSearchQuery } from './actions'
